document.addEventListener("DOMContentLoaded", function () {
  const mainFeaturesScrollContainer = document.querySelector(".main-features");

  let isDown = false;
  let startX;
  let scrollLeft;

  mainFeaturesScrollContainer.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - mainFeaturesScrollContainer.offsetLeft;
    scrollLeft = mainFeaturesScrollContainer.scrollLeft;
  });

  mainFeaturesScrollContainer.addEventListener("mouseleave", () => {
    isDown = false;
  });

  mainFeaturesScrollContainer.addEventListener("mouseup", () => {
    isDown = false;
  });

  mainFeaturesScrollContainer.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - mainFeaturesScrollContainer.offsetLeft;
    const walk = (x - startX) * 2; // kaydırma hızı
    mainFeaturesScrollContainer.scrollLeft = scrollLeft - walk;
  });
});
